const LandingSet = {
  //first part title
  title1: {
    English: "The path to"
  },
  title2: {
    English: "CX excellence for commerce"
  },
  title3: {
    English: ""
  },
  landingCopy: {
    English:
      "As customers continue to pull sales into digital channels, commerce has quickly emerged as a pivotal capability that every business needs to master. Consumers and businesses expect more from merchants and suppliers than ever. They want self-service experiences and the ability to browse, build, and buy what they need quickly and efficiently. To win in this competitive environment, your ecommerce platform must maximize agility, scalability, and innovation to satisfy customer and business needs alike."
  },
  landingCopy2: {
    English:
      "There is never-before-seen growth in today’s ecommerce space. Whether you’re just getting started, or you’re maturing your experience, you have the power at your fingertips to craft a powerful commerce solution. Use this tool to score your organization’s approach to ecommerce and learn where you are on the path to CX excellence for commerce."
  },
  getStarted: {
    English: "Get started",
    German: "Loslegen",
    French: "Commencer",
    Russian: "Начать",
    Turkish: "Başla",
    Italian: "Inizia",
    Spanish: "Comenzar",
    PortugueseBR: "Comece já",
    SpanishLAD: "Introducción",
  },
  restartBtn: {
    English: "Restart",
    German: "Neustarten",
    French: "Recommencer",
    Russian: "Начать сначала",
    Turkish: "Tekrar Başlat",
    Italian: "Ricomincia",
    Spanish: "Reiniciar",
    PortugueseBR: "Reiniciar",
    SpanishLAD: "Reiniciar",
  },
  nextBtn: {
    English: "Next",
    German: "Weiter",
    French: "Suivant",
    Russian: "Далее",
    Turkish: "Sonraki",
    Italian: "Avanti",
    Spanish: "Siguiente",
    PortugueseBR: "Avançar",
    SpanishLAD: "Siguiente",
  },
  finishBtn: {
    English: "Finish",
    German: "Beenden",
    French: "Terminer",
    Russian: "Завершить",
    Turkish: "Bitir",
    Italian: "Termina",
    Spanish: "Finalizar",
    PortugueseBR: "Concluir",
    SpanishLAD: "Finalizar",
  },
};

export default LandingSet;
